import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { t } from '../../locales';
import { ActionButton, Backdrop } from '../../components/Themed.js';
import { clearAppointments } from '../../data/appointment/AppointmentActions.js';
import {
  getIntakeForms,
  getCustomFields,
  clearCache,
} from '../../data/app/AppActions.js';
import { getEmployees } from '../../data/employee/EmployeeActions.js';
import { setNewClient } from '../../data/client/ClientActions';
import './Home.css';

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.newClientClick = this.newClientClick.bind(this);
    this.checkInClick = this.checkInClick.bind(this);
    this.checkInClassClick = this.checkInClassClick.bind(this);
    this.clearCacheClick = this.clearCacheClick.bind(this);
  }

  componentDidMount() {
    const {
      intakeForms,
      customFields,
      employees,
      clearAppointments,
      getIntakeForms,
      getCustomFields,
      getEmployees,
    } = this.props;

    clearAppointments()

    if (!intakeForms || !customFields || !employees) {
      getIntakeForms();
      getCustomFields();
      getEmployees(this.props.location.id);
    }
  }

  newClientClick() {
    this.props.setNewClient(true);
    this.props.history.push('/clientInformation');
  }

  checkInClick() {
    this.props.history.push('/clientCheckin');
  }

  checkInClassClick() {
    this.props.history.push('/classCheckin');
  }

  clearCacheClick() {
    this.props.clearCache();
  }

  render() {
    const {
      isTakingAppointments,
      classesCheckinEnabled,
    } = this.props;

    return (
      <React.Fragment>
        <Backdrop id="backdrop" />
        <div className="scroll-container content-container">
          <div className="title">
            {t('home_page.welcome_to')} {this.props.companyName}
          </div>
          <div className="content">
            {classesCheckinEnabled && (
              <ActionButton onClick={this.checkInClassClick}>
                {t('home_page.class_check_in')}
              </ActionButton>
            )}
            {isTakingAppointments && (
              <ActionButton onClick={this.checkInClick}>
                {t('home_page.appointment_check_in')}
              </ActionButton>
            )}
            <ActionButton onClick={this.newClientClick}>
              {t('home_page.walk_in')}
            </ActionButton>
            {/*
            <div style={{position:'absolute', top: '20px', right: '20px'}}>
              <a href="#" style={{color: '#ffffff'}} onClick={ this.clearCacheClick }>
                Signout
              </a>
            </div>
            */}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    companyName: state.app.businessInfo.company.name,
    companyId: state.app.businessInfo.company.id,
    bookRealAppointments:
      state.app.businessInfo.company.real_appointments_on_kiosk,
    location: state.app.location,
    intakeForms: state.app.intakeForms,
    customFields: state.app.customFields,
    employees: state.employee.employees,
    isTakingAppointments: state.app.businessInfo.company.take_appointments,
    classesCheckinEnabled: state.app.businessInfo.company.classes_enabled
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    {
      setNewClient,
      getIntakeForms,
      getCustomFields,
      getEmployees,
      clearCache,
      clearAppointments,
    }
  )(Home)
);
